export default __webpack_public_path__ + "static/media/illustration-hero-with-animals.88fc06b7.png";